import { Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import ragService from "../../services/ragService";
import { truncateSentence } from "../../shared/sharedFunctions";

const CompleteRagsModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleRagClick = (rag) => {
		props.onCompletedRagClick(rag);
	};
	
	return (
		<Dialog
			open={props.show? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Completed Risks
			</DialogTitle>
			<DialogContent>
				<TableContainer component={Paper} sx={{ width: "100%" }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: "left" }}>Title</TableCell>
								<TableCell sx={{ textAlign: "left" }}>Category</TableCell>
								<TableCell sx={{ textAlign: "left" }}>Description</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{ragService.completedRags? ragService.completedRags.map((rag, i) => {
								return (
									<TableRow
										onClick={() => { handleRagClick(rag); }}
										sx={{
											":hover": { cursor: "pointer" }
										}}
									>
										<TableCell>
											{`${rag.title}`}
										</TableCell>
										<TableCell>
											{`${rag.category}`}
										</TableCell>
										<TableCell>
											{(rag.description_short.length > 99)?
												`${truncateSentence(rag.description_short, 99)} ...`
													: rag.description_short
											}
										</TableCell>
									</TableRow>
								);
							}) : <React.Fragment/> }
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
		</Dialog>
	);

}

export default CompleteRagsModal;